export default {"src":"/_next/static/media/quotes.bb5beb2f.svg","height":57,"width":80,"blurWidth":0,"blurHeight":0};